<script lang="ts">
  import CompanyLogo from "../basic/companyLogo/company-logo.svelte";
  import Icon from "./blog-icons.svelte";

  export let companyName: string;
  export let companyUrl: string;
  export let description: string;
  export let logoUrl: string;
  // export let endorsementCount: number;

  const tempAvatar = "https://placehold.co/40x40";
</script>

<div class="py-6">
  <div class="mb-6 flex items-start gap-6">
    <CompanyLogo imageUrl={logoUrl} altText={`${companyName} logo`} outline wrapperClass="w-17 h-17" />
    <div class="space-y-2">
      <h2 class="text-xl font-bold">{companyName}</h2>
      <a href={`https://${companyUrl}`} target="_blank" class="text-xs font-light underline">{companyUrl}</a>
    </div>
  </div>

  <p class="text-sm leading-relaxed text-blog-gray-900 dark:text-blog-gray-300">
    {description}
  </p>

  <!-- <div class="flex items-center justify-between">
    <div class="flex gap-1">
      <button class="p-2" aria-label="Like">
        <Icon name="thumbs-up" size={26} />
      </button>
      <button class="p-2" aria-label="Dislike">
        <Icon name="thumbs-down" size={26} />
      </button>
    </div>

    <div class="flex items-center mt-2">
      <div class="flex -space-x-2">
        {#each Array(4) as _, i}
          <img src={tempAvatar} alt="avatar" class="w-9 h-9 p-1 bg-white rounded-full border border-black" />
        {/each}
      </div>
      <span class="ml-2 text-xs text-gray-600 font-thin">+ {endorsementCount}</span>
    </div>
  </div> -->
</div>
